import React, { useState, useEffect } from 'react';
import './ProjectGallery.css';

const ProjectGallery = ({ project, isOpen, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setCurrentImageIndex(0);
    } else {
      document.body.style.overflow = 'unset';
    }

    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !project) return null;

  const handlePrevious = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentImageIndex((prev) => 
        prev === 0 ? project.images.length - 1 : prev - 1
      );
      setIsAnimating(false);
    }, 300);
  };

  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentImageIndex((prev) => 
        prev === project.images.length - 1 ? 0 : prev + 1
      );
      setIsAnimating(false);
    }, 300);
  };
  return (
    <div className="gallery-overlay" onClick={onClose}>
      <div className="gallery-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="gallery-close" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="18" y1="6" x2="6" y2="18" strokeWidth="2" strokeLinecap="round"/>
            <line x1="6" y1="6" x2="18" y2="18" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>

        {/* Project Header */}
        <div className="gallery-header">
          <h2>{project.title}</h2>
          <span className="gallery-counter">
            {currentImageIndex + 1} / {project.images.length}
          </span>
        </div>

        {/* Main Image */}
        <div className="gallery-main-image">
          <img 
            src={project.images[currentImageIndex]} 
            alt={`${project.title} - preview ${currentImageIndex + 1}`}
            className={isAnimating ? 'image-animating' : ''}
          />
          
          {/* Navigation Arrows */}
          {project.images.length > 1 && (
            <>
              <button 
                className="gallery-nav gallery-nav-prev" 
                onClick={handlePrevious}
                disabled={isAnimating}
              >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="15 18 9 12 15 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button 
                className="gallery-nav gallery-nav-next" 
                onClick={handleNext}
                disabled={isAnimating}
              >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="9 18 15 12 9 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </>
          )}
        </div>

       

        {/* Project Info */}
        <div className="gallery-info">
          <p>{project.description}</p>
          <div className="gallery-tech">
            {project.tech.map((tech, idx) => (
              <span key={idx} className="tech-tag">{tech}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectGallery;